/** @format */

import React, { useEffect, useState } from "react";
import "./index.scss";
import BasicInfo from "./basic-info";
import TimeLineInfo from "./timeline-info";
import FormDetails from "./form-details";
import { invokeApi, HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { useParams, useNavigate } from "react-router";
import ViewTicket from "../past-ticket/view-ticket";
import { Drawer, Grid, Skeleton } from "@mui/material";
import { TICKET_STAGES } from "../../../utils/constants";
import PreDefectCodeStage from "./pre-defect-code-stage";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import BasicInfo2 from "./basic-info2";
import TicketFiles from "./ticket-files";
import TicketAttachments from "./ticket-attachments";

const TicketDetailsV2 = () => {
  const { id } = useParams();
  const [timeline, setTimeline] = useState([]);
  const [ticketDetails, setTicketDetails] = useState({});
  const [viewComplaint, setViewComplaint] = useState(null);
  const [complaintForm, setComplaintForm] = useState({});
  const [serviceEngineers, setServiceEngineers] = useState([]);
  const [codes, setCodes] = useState([]);
  const [parts, setParts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setIsLoading(true);
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${id}`,
      null
    )
      .then((response) => {
        if (response.code === 404) {
          toast.error("Invalid ticket");
          return;
        }
        if (response.ticket) {
          setTicketDetails(response.ticket);
          loadCodes(response.ticket.stage);
          loadServiceEngineers(response.ticket.stage);
        }
        if (response.complaintForm) {
          setComplaintForm({
            ...response.complaintForm,
            ticketId: (response.ticket && response.ticket.id) || 0,
          });
        }
        if (response.timeline && Array.isArray(response.timeline)) {
          setTimeline(response.timeline);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };

  const loadCodes = (stage) => {
    if (
      stage !== TICKET_STAGES.UPDATE_ACTION_CODE &&
      stage !== TICKET_STAGES.UPDATE_DEFECT_CODE &&
      stage !== TICKET_STAGES.JIR_CREATED &&
      stage !== TICKET_STAGES.ENGINE_REPLACEMENT_REJECTED
    ) {
      return;
    }
    let type = "defect";
    if (stage === TICKET_STAGES.UPDATE_ACTION_CODE) {
      type = "action";
    }
    loadParts();

    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type,
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: ele.code,
            value: ele.id,
            placeholder: `${ele.code}-${ele.description}`,
          }));
          setCodes(codeList);
        }
      })
      .catch((err) => console.error(err));
  };

  const loadParts = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "part",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response) {
          const partList = response.map((ele) => ({
            label: ele.description,
            value: ele.id,
          }));
          setParts(partList);
        }
      })
      .catch((err) => console.error(err));
  };

  const loadServiceEngineers = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_ENGINEER}`,
      null,
      {
        role: "serviceEngineer",
        page: 1,
        limit: 1000,
      }
    )
      .then((response) => {
        if (response.results) {
          const result = response.results.map((ele) => ({
            ...ele,
            label: ele.name,
            value: ele.id,
          }));
          setServiceEngineers(result);
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="page-body page-load">
      <div className=" view-detailed-ticket">
        <ArrowBackIcon
          sx={{ cursor: "pointer", marginRight: "20px" }}
          onClick={() => {
            if (showAttachments) {
              setShowAttachments(false);
            } else {
              navigate(-1);
            }
          }}
        />
        <div className="border-r">
          <p className="tab-name">Complaint Handling</p>
          <p className="section-name">Service Tickets</p>
        </div>
        <div>
          <p className="tab-name">Ticket ID</p>
          <p className="section-name">{id}</p>
        </div>
      </div>

      {!showAttachments && (
        <Grid container>
          <Grid item md={9} xs={12}>
            <BasicInfo
              ticketDetails={ticketDetails}
              serviceEngineers={serviceEngineers}
              loadData={loadData}
              complaintForm={complaintForm}
              codes={codes}
              parts={parts}
              setShowAttachments={setShowAttachments}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <BasicInfo2
              ticketDetails={ticketDetails}
              serviceEngineers={serviceEngineers}
              loadData={loadData}
              complaintForm={complaintForm}
              codes={codes}
              parts={parts}
              loadParts={loadParts}
              setShowAttachments={setShowAttachments}
            />
          </Grid>
        </Grid>
      )}
      {showAttachments && (
        <TicketAttachments
          ticketDetails={ticketDetails}
          timeline={timeline}
          openForm={() => setViewComplaint(true)}
          onDateChange={loadData}
          loadData={loadData}
          setViewComplaint={setViewComplaint}
        />
      )}
    </div>
  );
};

export default TicketDetailsV2;
